import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { router } from "../router/index";
import {
  setLocalStorage,
  clearLocalStorage,
  setLocalStorageNewTokenKey,
  setLocalStorageExpiredStatus,
} from "../js/oauth";
import { setSnackBarInfo } from "../js/common_function";

const AXIOS = axios.create({
  baseURL: "/api",
  timeout: 20000,
});

const state = {
  loading: false,
  selection: 1,
  topNum: 10,
  statsCards: [
    {
      type: "warning",
      icon: "fas fa-laugh-wink",
      title: "인기 기능",
      value: "",
      footerText: "최근 24시간 기준",
      footerIcon: "fas fa-hourglass-half",
    },
    {
      type: "success",
      icon: "fas fa-user-friends",
      title: "오늘 방문",
      value: "",
      footerText: "최근 24시간 기준",
      footerIcon: "fas fa-hourglass-half",
    },
    {
      type: "danger",
      icon: "fas fa-users",
      title: "총 방문",
      value: "",
      footerText: "개설 후 지금까지",
      footerIcon: "fas fa-hourglass-end",
    },
    {
      type: "info",
      icon: "fas fa-child",
      title: "가입자 수",
      value: "",
      footerText: "총 가입자 수",
      footerIcon: "fas fa-hourglass-end",
    },
  ],
  weatherCards: [
    {
      type: "warning",
      icon: "fas fa-map-marker-alt",
      title: "현재 위치",
      value: "",
      footerText: "",
      footerIcon: "fas fa-clock",
    },
    {
      type: "success",
      icon: "fas fa-temperature-high",
      title: "최고기온",
      value: "",
      footerText: "",
      footerIcon: "fas fa-quote-left",
    },
    {
      type: "success",
      icon: "fas fa-temperature-low",
      title: "최저기온",
      value: "",
      footerText: "",
      footerIcon: "fas fa-quote-left",
    },
    {
      type: "danger",
      icon: "fas fa-umbrella",
      title: "강수확률",
      value: "",
      footerText: "",
      footerIcon: "fas fa-quote-left",
    },
    {
      type: "info",
      icon: "fas fa-cloud",
      title: "하늘상태",
      value: "",
      footerText: "",
      footerIcon: "fas fa-quote-left",
    },
    {
      type: "info",
      icon: "fas fa-water",
      title: "습도",
      value: "",
      footerText: "",
      footerIcon: "fas fa-quote-left",
    },
  ],
  usersChart: {
    labels: [],
    series: [],
  },
  ticketPriceTrackingChart: {
    labels: [],
    series: [],
  },
  activityChart: {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    series: [
      [542, 543, 520, 680, 653, 753, 326, 434, 568, 610, 756, 895],
      [230, 293, 380, 480, 503, 553, 600, 664, 698, 710, 736, 795],
    ],
  },
  preferencesChart: {
    labels: ["62%", "32%", "6%"],
    series: [62, 32, 6],
  },
};

const getters = {
  isChartLabels(state) {
    return state.usersChart.labels;
  },
  isChartSeries(state) {
    return state.usersChart.series;
  },
  isPriceChartLabels(state) {
    return state.ticketPriceTrackingChart.labels;
  },
  isPriceChartSeries(state) {
    return state.ticketPriceTrackingChart.series;
  },
  isUserchartData(state) {
    return state.usersChart;
  },
  isStatsCards(state) {
    return state.statsCards;
  },
  isWeatherCards(state) {
    return state.weatherCards;
  },
  isTopNum(state) {
    return state.topNum;
  },
};

const mutations = {
  SET_LABELS(state, labels) {
    state.usersChart.labels = labels;
  },
  SET_TICKET_PRICE_TRACKING_LABELS(state, labels) {
    state.ticketPriceTrackingChart.labels = labels;
  },
  SET_BULLETIN_LOG(state, bulletinLog) {
    state.usersChart.series[0] = bulletinLog;
  },
  SET_SCHEDULEMNG_LOG(state, scheduleMngLog) {
    state.usersChart.series[1] = scheduleMngLog;
  },
  SET_VISITORSBOOK_LOG(state, visitorsBookLog) {
    state.usersChart.series[2] = visitorsBookLog;
  },
  SET_PRIVATEBULLETIN_LOG(state, privateBulletinLog) {
    state.usersChart.series[3] = privateBulletinLog;
  },
  SET_TICKET_PRICE_TRACKING(state, ticketPriceTracking) {
    state.ticketPriceTrackingChart.series[0] = ticketPriceTracking;
  },
  SET_FAMOUS(state, data) {
    state.statsCards[0].value = data;
  },
  SET_TOP_NUM(state, data) {
    state.topNum = data;
  },
  SET_VISITOR(state, data) {
    state.statsCards[1].value = data + "회";
  },
  SET_TOTAL_VISITOR(state, data) {
    state.statsCards[2].value = data + "회";
  },
  SET_MEMBER(state, data) {
    state.statsCards[3].value = data + "명";
  },

  SET_LOCATION(state, data) {
    state.weatherCards[0].value = data.city;
    state.weatherCards[0].footerText = data.datetime + " 발표 예보";
  },
  SET_CELCIUS_HIGH(state, data) {
    state.weatherCards[1].value = data.tmx + "도";
    state.weatherCards[1].footerText =
      "다음(날)" + data.fcstTimeCelcius.substring(0, 2) + "시" + " 기준 예보";
  },
  SET_CELCIUS_LOW(state, data) {
    state.weatherCards[2].value = data.tmn + "도";
    state.weatherCards[2].footerText =
      "다음(날)" + data.fcstTimeCelcius.substring(0, 2) + "시" + " 기준 예보";
  },
  SET_PRECIPITATION(state, data) {
    state.weatherCards[3].value = data.pop + "%";
    state.weatherCards[3].footerText =
      data.fcstTimeNormal.substring(0, 2) + "시" + " 기준 예보";
  },
  SET_SKY(state, data) {
    state.weatherCards[4].value = data.skyString;
    state.weatherCards[4].footerText =
      data.fcstTimeNormal.substring(0, 2) + "시" + " 기준 예보";
  },
  SET_HUMIDITY(state, data) {
    state.weatherCards[5].value = data.reh + "%";
    state.weatherCards[5].footerText =
      data.fcstTimeNormal.substring(0, 2) + "시" + " 기준 예보";
  },
};

const actions = {
  async CHART_DATA_CALL(context) {
    try {
      const response = await chartData();
      // console.log(response.data);

      const labels = [];
      const bulletinLog = [];
      const scheduleMngLog = [];
      const visitorsBookLog = [];
      const privateBulletinLog = [];
      let check = false;
      let topNum = 0;

      response.data.labels.map(function (value, key) {
        labels[key] = value.labels;

        check = false;

        response.data.bulletinLog.map(function (value2, key2) {
          if (check == false) {
            if (value.labels == value2.ts) {
              if (value2.count > topNum) {
                topNum = value2.count;
              }
              bulletinLog[key] = value2.count;
              check = true;
            } else {
              bulletinLog[key] = 0;
              check = false;
            }
          }
        });
        check = false;
        response.data.scheduleMngLog.map(function (value3, key3) {
          if (check == false) {
            if (value.labels == value3.ts) {
              if (value3.count > topNum) {
                topNum = value3.count;
              }
              scheduleMngLog[key] = value3.count;
              check = true;
            } else {
              scheduleMngLog[key] = 0;
              check = false;
            }
          }
        });
        check = false;
        response.data.visitorsBookLog.map(function (value4, key4) {
          if (check == false) {
            if (value.labels == value4.ts) {
              if (value4.count > topNum) {
                topNum = value4.count;
              }
              visitorsBookLog[key] = value4.count;
              check = true;
            } else {
              visitorsBookLog[key] = 0;
              check = false;
            }
          }
        });
        check = false;
        response.data.privateBulletinLog.map(function (value5, key5) {
          if (check == false) {
            if (value.labels == value5.ts) {
              if (value5.count > topNum) {
                topNum = value5.count;
              }
              privateBulletinLog[key] = value5.count;
              check = true;
            } else {
              privateBulletinLog[key] = 0;
              check = false;
            }
          }
        });
      });
      context.commit("SET_LABELS", labels);
      context.commit("SET_TOP_NUM", topNum);
      context.commit("SET_BULLETIN_LOG", bulletinLog);
      context.commit("SET_SCHEDULEMNG_LOG", scheduleMngLog);
      context.commit("SET_VISITORSBOOK_LOG", visitorsBookLog);
      context.commit("SET_PRIVATEBULLETIN_LOG", privateBulletinLog);
      return true;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("조회 실패. 로그 확인"));
      return false;
    }
  },
  async PRICE_CHART_DATA_CALL(context) {
    try {
      const response = await ticketPriceTrackingFunc();

      const ticketPriceTrackingLabels = [];
      const ticketPriceTracking = [];

      response.data.map(function (value, key) {
        ticketPriceTrackingLabels[key] = value.date;
        ticketPriceTracking[key] = value.price;
      });

      context.commit(
        "SET_TICKET_PRICE_TRACKING_LABELS",
        ticketPriceTrackingLabels
      );
      context.commit("SET_TICKET_PRICE_TRACKING", ticketPriceTracking);
      return true;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("조회 실패. 로그 확인"));
      return false;
    }
  },
  async CARD_DATA_CALL(context) {
    try {
      const response = await cardData();
      // console.log(response)
      if (response.data.topFunc[0].func != null) {
        context.commit("SET_FAMOUS", response.data.topFunc[0].func);
      }
      context.commit("SET_MEMBER", response.data.totalCountMember[0].count);
      context.commit("SET_VISITOR", response.data.countVisit[0].count);
      context.commit(
        "SET_TOTAL_VISITOR",
        response.data.totalCountVisit[0].count
      );

      return true;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("조회 실패."));
      return false;
    }
  },

  async WEATHER_DATA_CALL(context) {
    try {
      const response = await weatherData();

      var celciusObj = [];
      celciusObj.tmx = response.data.tmx;
      celciusObj.tmn = response.data.tmn;
      celciusObj.fcstTimeCelcius = response.data.fcstTimeCelcius;

      var normalObj = [];
      normalObj.fcstTimeNormal = response.data.fcstTimeNormal;
      normalObj.pop = response.data.pop;
      normalObj.reh = response.data.reh;

      context.commit("SET_PRECIPITATION", normalObj);
      context.commit("SET_HUMIDITY", normalObj);
      context.commit("SET_CELCIUS_HIGH", celciusObj);
      context.commit("SET_CELCIUS_LOW", celciusObj);

      var cityObj = [];
      cityObj.city = response.data.city;
      cityObj.datetime = response.data.datetime;
      context.commit("SET_LOCATION", cityObj);
      // console.log(response.data.sky)
      if (response.data.sky == 1) {
        normalObj.skyString = "맑음";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.sky == 3 && response.data.pty == 0) {
        normalObj.skyString = "구름많음";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 1) {
        normalObj.skyString = "비";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 2) {
        normalObj.skyString = "비/눈";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 3) {
        normalObj.skyString = "눈";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 4) {
        normalObj.skyString = "소나기";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 5) {
        normalObj.skyString = "빗방울";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 6) {
        normalObj.skyString = "빗방울/눈날림";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 7) {
        normalObj.skyString = "눈날림";
        context.commit("SET_SKY", normalObj);
      } else {
        normalObj.skyString = "흐림";
        context.commit("SET_SKY", normalObj);
      }

      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("조회 실패."));
      return response;
    }
  },

  async GEO_DATA_CALL(context, obj) {
    try {
      // console.log("here is geo data call")
      const response = await geoDataCall(obj);

      var celciusObj = [];
      celciusObj.tmx = response.data.tmx;
      celciusObj.tmn = response.data.tmn;
      celciusObj.fcstTimeCelcius = response.data.fcstTimeCelcius;

      var normalObj = [];
      normalObj.fcstTimeNormal = response.data.fcstTimeNormal;
      normalObj.pop = response.data.pop;
      normalObj.reh = response.data.reh;

      context.commit("SET_PRECIPITATION", normalObj);
      context.commit("SET_HUMIDITY", normalObj);
      context.commit("SET_CELCIUS_HIGH", celciusObj);
      context.commit("SET_CELCIUS_LOW", celciusObj);

      var cityObj = [];
      cityObj.city = response.data.city;
      cityObj.datetime = response.data.datetime;
      context.commit("SET_LOCATION", cityObj);
      // console.log(response.data.sky)
      if (response.data.sky == 1) {
        normalObj.skyString = "맑음";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.sky == 3 && response.data.pty == 0) {
        normalObj.skyString = "구름많음";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 1) {
        normalObj.skyString = "비";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 2) {
        normalObj.skyString = "비/눈";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 3) {
        normalObj.skyString = "눈";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 4) {
        normalObj.skyString = "소나기";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 5) {
        normalObj.skyString = "빗방울";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 6) {
        normalObj.skyString = "빗방울/눈날림";
        context.commit("SET_SKY", normalObj);
      } else if (response.data.pty == 7) {
        normalObj.skyString = "눈날림";
        context.commit("SET_SKY", normalObj);
      } else {
        normalObj.skyString = "흐림";
        context.commit("SET_SKY", normalObj);
      }

      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("조회 실패."));
      return response;
    }
  },
};

function chartData() {
  return AXIOS({
    url: "/analysis/allLogsAnalysis",
    method: "get",
  });
}

function ticketPriceTrackingFunc() {
  return AXIOS({
    url: "/analysis/ticketPriceTracking",
    method: "get",
  });
}

function cardData() {
  return AXIOS({
    url: "/analysis/comprehensiveInfo",
    method: "get",
  });
}

function geoDataCall(obj) {
  return AXIOS({
    url: "/weatherInfo",
    method: "post",
    data: {
      path: obj.path,
      latitude: obj.latitude,
      longtitude: obj.longtitude,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function weatherData() {
  return AXIOS({
    url: "/weatherInfo",
    method: "post",
    data: {
      path: "/",
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

export default {
  state,
  actions,
  mutations,
  getters,
};
